module.exports = __webpack_public_path__ + "img/Industrial.4f255f6a.png";